export default ['Book', 'Manuscript', 'Pilot', 'Screenplay', 'Television', 'Other'];
